import React from 'react'

const WindowContext = React.createContext(null);

export { WindowContext };

export const WindowContextProvider = props => {
    const [windowIsActive, setWindowIsActive] = React.useState(true)
  
  
    function handleActivity(forcedFlag) {
      if (typeof forcedFlag === 'boolean') {
        return forcedFlag ? setWindowIsActive(true) : setWindowIsActive(false)
      }
  
      return document.hidden ? setWindowIsActive(false) : setWindowIsActive(true)
    }
  
    React.useEffect(() => {
      const handleActivityFalse = () => handleActivity(false)
      const handleActivityTrue = () => handleActivity(true)
  
      document.addEventListener('visibilitychange', handleActivity)
      document.addEventListener('blur', handleActivityFalse)
      window.addEventListener('blur', handleActivityFalse)
      window.addEventListener('focus', handleActivityTrue )
      document.addEventListener('focus', handleActivityTrue)
  
      return () => {
        window.removeEventListener('blur', handleActivity)
        document.removeEventListener('blur', handleActivityFalse)
        window.removeEventListener('focus', handleActivityFalse)
        document.removeEventListener('focus', handleActivityTrue )
        document.removeEventListener('visibilitychange', handleActivity)
        
        setWindowIsActive(false);
      }
    }, [])
  
    return <WindowContext.Provider value={{ windowIsActive }}>{props.children}</WindowContext.Provider>
  }